import React from 'react';
import { graphql, Link } from 'gatsby';

import {
    className,
    Text,
    Heading,
    ImageComponent,
} from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';
import { useTranslate } from 'soluble-gatsby-source';
import BlogMetasComponent from '../BlogMetasComponent';

import style from './style.module.scss';

import transitionStyle from 'aplazame-design-system/src/scss/transitions.module.scss';

export default function BlogItemComponent({
    title,
    excerpt,
    slug,
    by,
    date,
    readingTime,
    featuredImage,
    categoryPages,
    authorPage,
    imageAspectRatio,
    wrapperClassName,
    buttonClassName,
    minimal,
}) {
    const translation = useTranslate();
    const metas = [
        authorPage
            ? translation['wordpress-posts-section.blog-item.by'].text.replace(
                  '{author}',
                  `<a class="author-link" href="/${authorPage.slug}/">${authorPage.title}</a>`
              )
            : by,
        readingTime,
    ].filter((i) => !!i);

    return (
        <div
            {...className(
                `${style.wrapper} ${
                    wrapperClassName ? wrapperClassName : ''
                } pb-lg-9`
            )}
        >
            {!minimal &&
            featuredImage &&
            featuredImage.node &&
            featuredImage.node.localFile ? (
                <Link to={`/${slug}/`}>
                    <ImageComponent
                        className={`mb-2 ${style.image}`}
                        image={{
                            file: featuredImage.node.localFile,
                            alt: title,
                        }}
                        aspectRatio={imageAspectRatio ? imageAspectRatio : 1.36}
                    />
                </Link>
            ) : null}
            <BlogMetasComponent categoryPages={categoryPages} date={date} />
            <Link to={`/${slug}/`} className={transitionStyle.link}>
                <Heading
                    className={`${minimal ? 'h4 mb-2' : 'h5 mb-1'} ${
                        style.heading
                    }`}
                    tag="h4"
                >
                    {title}
                </Heading>
            </Link>
            {!minimal ? (
                <Text
                    tag="span"
                    className={`body d-block mb-3 ${transitionStyle['child-link']} ${style.metas}`}
                >
                    {metas.join(' | ')}
                </Text>
            ) : null}
            {!minimal ? (
                <Text
                    tag="div"
                    className={`body mb-2 ${style.text} ${transitionStyle['child-link']} ${style.metas}`}
                >
                    {excerpt}
                </Text>
            ) : null}
            <ButtonComponent
                buttonClassName={`${style.button} ${
                    buttonClassName ? buttonClassName : ''
                }`}
                button={{
                    label:
                        translation[
                            'wordpress-posts-section.blog-item.read-more'
                        ].text,
                    link: { slug },
                }}
            />
        </div>
    );
}

export const query = graphql`
    fragment BlogItem on WpPost {
        ...BlogItemMetas
        title
        excerpt
        slug
        by
        readingTime
        featuredImage {
            node {
                localFile {
                    publicURL
                    childImageSharp {
                        fluid(maxWidth: 1268, maxHeight: 806) {
                            ...GatsbyImageSharpFluid_withWebp
                        }
                    }
                }
            }
        }
        authorPage {
            title
            slug
        }
    }
`;
